import { makeStyles, Theme } from "@material-ui/core/styles";

interface Props {
  titlePadding?: string;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  paper: {
    padding: theme.spacing(5),
  },
  titleWrapper: {
    marginBottom: theme.spacing(5),
    paddingLeft: ({ titlePadding }) => titlePadding || theme.spacing(5),
  },
  titleLabelStyle: {
    color: "#4B5D72",
  },
  content: { marginBottom: theme.spacing(5) },
  right: {
    paddingRight: theme.spacing(1),
    "& > *": {
      marginRight: theme.spacing(1),
    },
  },
}));

export default useStyles;
